export default __webpack_public_path__ + "static/help_02_08_1-e8f13f6d4d252749e2d0d8918cca58c4.png";